<template>
	<video ref="vid"
	       :autoplay="cAutoplay"
	       :loop="cLoop"
	       :muted="muted"
	       :playsinline="playsinline"
	       :poster="poster"
	       class="video-element"
	       @ended="onEnded"
	       @error="onError"
	       @loadeddata="onReady"
	>
		<source v-for="(src, id) in sources"
		        :key="id" :src="src"
		        :type="getMimeType(src)"
		/>
	</video>
</template>

<script>
import {getMimeTypeFromExtension} from "@/components/graphics/Graphics";

export default {
	name: "VideoElement",
	emits: ['ready', 'ended'],
	inheritAttrs: false,
	props: {
		sources: {
			type: Array,
			default: () => {
				return [];
			}
		},
		autoplay: {
			type: Boolean,
			default: false
		},
		poster: {
			type: String,
			default: null
		},
		loop: {
			type: Boolean,
			default: false
		},
		loopCount: {
			type: Number,
			default: 0
		},
		muted: {
			type: Boolean,
			default: false
		},
		playsinline: {
			type: Boolean,
			default: true
		},
		delay: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loops: 0
		}
	},

	computed: {
		cLoop() {
			return this.loopCount === 0 && this.loop && this.delay === 0;
		},
		cAutoplay() {
			return this.autoplay && this.delay === 0;
		}
	},
	methods: {
		getMimeType(src) {
			return getMimeTypeFromExtension(src);
		},
		onError(e) {
			console.log("Error Playing Source:", this.$ref?.vid?.src, "\n", e);
		},
		play() {
			this.$refs.vid.play();
		},
		pause() {
			this.$refs.vid.pause();
		},
		seek(time) {
			this.$refs.vid.currentTime = time;
		},
		getDuration() {
			return this.$refs.vid.duration;
		},
		restLoops() {
			this.loops = 0;
		},
		/**
		 * Starts playback with an optional delay based on the `delay` property.
		 * If `delay` is greater than 0, playback is delayed by the specified number of seconds.
		 * Otherwise, playback begins immediately.
		 *
		 * @return {void} Does not return a value.
		 */
		start(from = 0) {
			if (this.delay > 0) {
				setTimeout(() => {
					this.seek(from);
					this.play();
				}, this.delay * 1000);
			} else {
				this.seek(from);
				this.play();
			}
		},
		onReady() {
			if (this.autoplay) {
				this.start();
			}
			this.$emit('ready');
		},
		onEnded() {
			if (this.loop && this.loopCount > 0 && this.loops < this.loopCount - 1) {
				this.loops++;
				this.start(0);
			} else if (this.loop && this.loopCount === 0 && this.delay > 0) {
				this.start(0);
			} else {
				///this.seek(0);
				this.$emit('ended');
			}
		}
	}
}
</script>


<style lang="scss" scoped>

</style>
